class RateLimiter {
    constructor(limitNum = 2) {
        this.maxConcurrent = limitNum // 最大并发数量
        this.callbacks = [] // 请求队列
        this.activeRequest = 0 //当前激活的请求
    }

    getAsyncRequest(request) {
        let _resolve,_reject
        const asyncRunner = async () => {
            await request()
                .then(res => _resolve(res))
                .catch(err => _reject(err))
        }
        this.callbacks.push({
            run: asyncRunner
        })
        this.flushQueue()
        return new Promise((resolve, reject) => {
            _resolve = resolve
            _reject = reject
        })
    }

    flushQueue() {
        if (this.activeRequest < this.maxConcurrent && this.callbacks.length > 0) {
            this.activeRequest++
            const req = this.callbacks.shift() 
            if (!req) return
            req.run().finally(() => {
                this.activeRequest--
                this.flushQueue()
            })
        }
    }

    clear() {
        this.callbacks = []
        this.activeRequest = 0
    }
}

export default RateLimiter